// Shared epilogue for every write*() that replaces one section's rows
// wholesale: an empty section written back as `[FOO]` with zero data rows
// still round-trips as a real (if pointless) section header, so a writer
// with nothing left to write must delete the key outright rather than set
// it to `[]`, or a later reader could mistake "section emptied" for
// "section untouched".
export function writeOrDeleteSection(
  raw: ReadonlyMap<string, string[][]>,
  section: string,
  rows: string[][]
): Map<string, string[][]> {
  const next = new Map(raw);
  if (rows.length === 0) next.delete(section);
  else next.set(section, rows);
  return next;
}
